// Vendor libraries
import { Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { CustomPDFReportsDropdownOption } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/enums/custom-pdf-reports-dropdown-option-enum';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Utils
import { getReportBuilderWizardSteps } from 'CustomPDFReportsApp/ts/utils/custom-pdf-reports-utils';
import { getSharingButtonConfig } from 'SharingApp/ts/utils/public-sharing-utils';
// Constants
import { GENERATE_PDF_REPORT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { REPORT_TYPE_LABELS, PDF_PREVIEW_PARAMS, PDF_PREVIEW_SECURITIES } from 'CustomPDFReportsApp/ts/constants';
// Components
import { ContentItemBase } from 'FoldersApp/directives/content-item-base.directive';
import { SimpleDropdownComponent } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.component';
// Services
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
// NgRx Store Actions
import { setCustomPDFReportToDuplicate } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/state/custom-pdf-report-to-duplicate/custom-pdf-report-to-duplicate.actions';
import { setSelectedReport } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i3 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i4 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i5 from "FoldersApp/features/folders-shared/folder-operations-dropdown/folder-operations-dropdown.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i9 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
import * as i10 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i11 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
function CustomPDFReportsFolderableListItemComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵpipe(2, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelement(4, "div", 7);
    i0.ɵɵpipe(5, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8)(7, "div", 9);
    i0.ɵɵtext(8, "--");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 10)(10, "div", 11)(11, "a", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(13, "ycn-folder-operations-dropdown", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    i0.ɵɵnextContext();
    const folderBase_r2 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(2, 9, folder_r1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(5, 11, folder_r1.modify_date, "longDate"));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", folder_r1)("folderIsDisabled", folderBase_r2.itemSelectionDisabled)("listItemView", true)("resourceType", ctx_r2.FolderItemType.FOLDER)("resourceTypeDescription", ctx_r2.folderable.resourceTypeDescription)("ancestorFolderId", ctx_r2.ancestorInfo.id);
} }
function CustomPDFReportsFolderableListItemComponent_Conditional_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-custom-pdf-reports-folderable-list-item", 15);
} if (rf & 2) {
    const folderable_r4 = ctx.folderable;
    const ancestorInfo_r5 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r4)("ancestorInfo", ancestorInfo_r5);
} }
function CustomPDFReportsFolderableListItemComponent_Conditional_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "span");
    i0.ɵɵtext(2, "There are no report templates in this folder.");
    i0.ɵɵelementEnd()();
} }
function CustomPDFReportsFolderableListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 5, 0);
    i0.ɵɵtemplate(2, CustomPDFReportsFolderableListItemComponent_Conditional_0_ng_template_2_Template, 14, 14, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, CustomPDFReportsFolderableListItemComponent_Conditional_0_ng_template_4_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, CustomPDFReportsFolderableListItemComponent_Conditional_0_ng_template_6_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r6 = i0.ɵɵreference(3);
    const listItemFragment_r7 = i0.ɵɵreference(5);
    const emptyFolderFragment_r8 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r2.folderable)("ancestorInfo", ctx_r2.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r6)("listItemFragment", listItemFragment_r7)("emptyFolderFragment", emptyFolderFragment_r8);
} }
function CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, ctx_r2.customPDFReport));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "label", 20)(3, "input", 21);
    i0.ɵɵlistener("click", function CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.bulkActionSelectionService.toggleSelectedItem(ctx_r2.folderable.resourceType, ctx_r2.customPDFReport.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 23)(6, "div", 24)(7, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 13);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 26);
    i0.ɵɵtext(10, "pdf");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 27);
    i0.ɵɵlistener("click", function CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.openInNewTab()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_div_12_Template, 3, 6, "div", 28);
    i0.ɵɵpipe(13, "isSharedWithOthers");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 6);
    i0.ɵɵelement(16, "div", 7);
    i0.ɵɵpipe(17, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 8);
    i0.ɵɵelement(19, "div", 7);
    i0.ɵɵpipe(20, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 8);
    i0.ɵɵelement(22, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 10)(24, "div", 11)(25, "a", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(26, "svg", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(27, "ycn-simple-dropdown", 31);
    i0.ɵɵlistener("handler", function CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_Template_ycn_simple_dropdown_handler_27_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.fileDropdownHandler($event)); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r2.itemIsSelected);
    i0.ɵɵproperty("folderable", ctx_r2.folderable)("ancestorInfo", ctx_r2.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.itemSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.itemIsSelected);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("disabled", !ctx_r2.itemSelectionEnabled)("pointer-events-none", !ctx_r2.itemSelectionEnabled);
    i0.ɵɵproperty("textContent", ctx_r2.customPDFReport.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 30, ctx_r2.customPDFReport));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.customPDFReport.report_description);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(17, 32, ctx_r2.customPDFReport));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(20, 34, ctx_r2.customPDFReport.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r2.REPORT_TYPE_LABELS[ctx_r2.customPDFReport.report_type]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", "Edit")("href", ctx_r2.editPageUrl, i0.ɵɵsanitizeUrl)("disabled", !(ctx_r2.customPDFReport.permissions == null ? null : ctx_r2.customPDFReport.permissions.canEdit) || ctx_r2.itemSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.relativePositionedElemId)("inputDisabled", ctx_r2.itemSelectionDisabled)("tooltipTitle", "More Options")("tooltipPlacement", "bottom")("buttonClass", "btn btn-secondary arrow-down")("config", ctx_r2.fileDropdownConfig)("dropdownClass", "dropdown-menu-right dropdown-menu-with-icons")("showDropdownCaret", false);
} }
function CustomPDFReportsFolderableListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CustomPDFReportsFolderableListItemComponent_Conditional_1_div_0_Template, 28, 37, "div", 17);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r2.bulkActionSelectionService.idsByResourceType$));
} }
/**
 * Component for displaying a list of custom pdf report folderable items.
 */
export class CustomPDFReportsFolderableListItemComponent extends ContentItemBase {
    get fileDropdownConfig() {
        const shareOption = {
            type: 'option',
            label: 'Share',
            value: CustomPDFReportsDropdownOption.SHARE,
            icon: 'icon-share',
            disabled: !this.customPDFReport.permissions.canShare,
        };
        const { label, disabled } = getSharingButtonConfig(shareOption, this.customPDFReport, this.customPDFReport.permissions.canShare);
        shareOption.label = label;
        shareOption.disabled = disabled;
        return {
            title: {
                label: '',
                icon: 'icon-dots-more',
            },
            list: [
                {
                    type: 'option',
                    label: 'Generate Report',
                    value: CustomPDFReportsDropdownOption.GENERATE_REPORT,
                    icon: 'icon-overview',
                    disabled: !(this.customPDFReport.permissions.canView && this.userHasGenerateFeature),
                },
                {
                    type: 'option',
                    label: 'Preview',
                    value: CustomPDFReportsDropdownOption.PREVIEW,
                    icon: 'icon-preview',
                },
                shareOption,
                {
                    type: 'option',
                    label: 'Rename',
                    value: CustomPDFReportsDropdownOption.RENAME,
                    icon: 'icon-edit',
                    disabled: !this.customPDFReport.permissions.canRename,
                },
                {
                    type: 'option',
                    label: 'Move',
                    value: CustomPDFReportsDropdownOption.MOVE,
                    icon: 'icon-folder-move',
                    disabled: !this.customPDFReport.permissions.canMove,
                },
                {
                    type: 'option',
                    label: 'Duplicate',
                    value: CustomPDFReportsDropdownOption.DUPLICATE,
                    icon: 'icon-duplicate',
                    disabled: !this.customPDFReport.permissions.canDuplicate,
                },
                {
                    type: 'option',
                    label: 'Delete',
                    value: CustomPDFReportsDropdownOption.DELETE,
                    icon: 'icon-delete',
                    disabled: !this.customPDFReport.permissions.canDelete,
                },
            ],
        };
    }
    get customPDFReport() {
        return this.folderable.item;
    }
    get relativePositionedElemId() {
        return `list-item-dropdown-${this.folderable.resourceType}-${this.folderable.item.id}`;
    }
    get editPageUrl() {
        return `/custom_pdf_reports/builder/?targetFolder=${this.folderableCollectionService?.viewRootFolder?.id ?? ''}#/?report=report_id:::${this.folderable.item.id}`;
    }
    constructor(injector) {
        super();
        this.injector = injector;
        this.FolderItemType = FolderableType;
        this.userHasGenerateFeature = false;
        this.REPORT_TYPE_LABELS = REPORT_TYPE_LABELS;
        // Retrieve dependencies from injector
        this.store = this.injector.get(Store);
        this.customPDFReportService = this.injector.get(CustomPDFReportService);
        this.urlsService = this.injector.get(UrlsService);
        this.featureService = this.injector.get(FeatureService);
        this.toastMessagesService = this.injector.get(PageToastMessagesService);
        this.folderableCollectionService = this.injector.get(FolderableCollectionServiceBase);
    }
    ngOnInit() {
        this.userHasGenerateFeature = this.featureService.userHasFeatures([GENERATE_PDF_REPORT_FEATURE]);
    }
    get itemSelectionEnabled() {
        return this.customPDFReport.permissions.canEdit;
    }
    get itemUrl() {
        return this.editPageUrl;
    }
    fileDropdownHandler(operationName) {
        const selectedOperation = {
            item: {
                id: this.customPDFReport.id,
                name: this.customPDFReport.name,
                itemType: this.folderable.resourceType,
                itemTypeDescription: this.folderable.resourceTypeDescription,
                ancestorFolderId: this.ancestorInfo.id,
                relativePositionedElemId: this.relativePositionedElemId,
                sharing: this.customPDFReport.sharing,
            },
            operation: operationName,
        };
        switch (operationName) {
            case CustomPDFReportsDropdownOption.DELETE:
            case CustomPDFReportsDropdownOption.MOVE:
            case CustomPDFReportsDropdownOption.RENAME:
            case CustomPDFReportsDropdownOption.SHARE:
                this.store.dispatch(setSelectedFolderableOperation({
                    selectedOperation,
                }));
                break;
            case CustomPDFReportsDropdownOption.DUPLICATE:
                this.store.dispatch(setCustomPDFReportToDuplicate({
                    customPDFReport: this.customPDFReport,
                    targetFolder: this.ancestorInfo.id,
                }));
                break;
            case CustomPDFReportsDropdownOption.PREVIEW:
                const simulateLinkClick = (url) => {
                    if (!url)
                        return;
                    const link = document.createElement('a');
                    link.setAttribute('href', url);
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                };
                const previewData = {
                    ...PDF_PREVIEW_PARAMS,
                    ...PDF_PREVIEW_SECURITIES[this.customPDFReport.num_required_securities],
                };
                const reportId = this.customPDFReport.report_id;
                const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PREVIEW_PDF_REPORT, { reportId }, previewData);
                simulateLinkClick(url);
                break;
            case CustomPDFReportsDropdownOption.GENERATE_REPORT:
                // Fetch generate report info for custom PDF reports
                this.customPDFReportService
                    .getGenerateReportInfo(this.customPDFReport.report_id, this.folderable.resourceType)
                    .subscribe({
                    next: (report) => {
                        const reportData = {
                            preview_image_url: null,
                            report_id: report.report_id,
                            report_type: report.report_type,
                            report_name: report.report_name,
                            report_description: report.report_description,
                            advanced_options: report.advanced_options,
                            num_required_securities: report.num_required_securities,
                            sections: this.customPDFReport.sections,
                            data_source: report.data_source,
                            wizard_steps: getReportBuilderWizardSteps(report),
                        };
                        this.store.dispatch(setSelectedReport({ reportData }));
                    },
                    error: () => {
                        this.toastMessagesService.addMessage('There was an issue selecting this report for generation.', ToastMessageType.ERROR);
                    },
                });
                break;
            default:
        }
    }
}
CustomPDFReportsFolderableListItemComponent.ɵfac = function CustomPDFReportsFolderableListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPDFReportsFolderableListItemComponent)(i0.ɵɵdirectiveInject(i0.Injector)); };
CustomPDFReportsFolderableListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPDFReportsFolderableListItemComponent, selectors: [["ycn-custom-pdf-reports-folderable-list-item"]], viewQuery: function CustomPDFReportsFolderableListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(SimpleDropdownComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownToggle = _t.first);
    } }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderBase", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], ["ycn-folderable", "", "data-test-id", "custom-pdf-report-list-item", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3", "col-md-2"], [1, "file-td-wrap", 3, "textContent"], [1, "td", "col-2"], [1, "file-td-wrap"], [1, "td", "file-td-grip", "col-3", "col-lg-1"], [1, "btn-group"], [1, "btn", "btn-secondary", 2, "visibility", "hidden"], ["ycnIcon", "", 3, "name"], [3, "item", "folderIsDisabled", "listItemView", "resourceType", "resourceTypeDescription", "ancestorFolderId"], [3, "folderable", "ancestorInfo"], [1, "get-started-small", "flex-auto"], ["class", "tr", "ycn-folderable", "", "data-test-id", "custom-pdf-report-list-item", 3, "bg-yc-blue-90", "folderable", "ancestorInfo", 4, "ngIf"], ["ycn-folderable", "", "data-test-id", "custom-pdf-report-list-item", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "td", "file-td-name"], [1, "file-name", "file-td-wrap"], [1, "file-icon", "file-pdf"], [1, "file-abbr"], ["draggable", "false", "data-test-id", "custom-pdf-report-list-item-name", "href", "javascript:void(0)", 3, "click", "textContent"], ["class", "btn btn-xs btn-circle btn-transparent btn-share ml-1", "ycnTooltip", "", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle", 4, "ngIf"], [1, "table-portfolios-descr", "ml-4", 3, "textContent"], ["ycnTooltip", "", "ycnDisabled", "", "data-test-id", "edit-report", 1, "btn", "btn-secondary", 3, "tooltipPlacement", "tooltipTitle", "href", "disabled"], ["ycnTooltip", "", "data-test-id", "custom-pdf-report-list-item-dropdown", 1, "dropdown", 3, "handler", "id", "inputDisabled", "tooltipTitle", "tooltipPlacement", "buttonClass", "config", "dropdownClass", "showDropdownCaret"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"]], template: function CustomPDFReportsFolderableListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, CustomPDFReportsFolderableListItemComponent_Conditional_0_Template, 8, 5)(1, CustomPDFReportsFolderableListItemComponent_Conditional_1_Template, 2, 3, "div", 4);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i1.NgIf, i2.DisabledDirective, i3.FolderableDirective, i4.FolderBaseComponent, i5.FolderOperationsDropdownComponent, i6.IconDirective, i7.SimpleDropdownComponent, i8.TooltipDirective, CustomPDFReportsFolderableListItemComponent, i1.AsyncPipe, i1.DatePipe, i9.GetOwnerDisplayName, i10.GetSharingTooltipMessage, i11.IsSharedWithOthersPipe], encapsulation: 2, changeDetection: 0 });
